import { GoodToKnowUI } from "./GoodToKnowUI";
import { StandardProps } from "../componentMap";
import { Product } from "../../types/types";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { EAN_NOT_FOUND, getEan } from "@/utils/variant/getEan";

function isChanelProduct(product: Product): boolean {
  return product?.brand?.name === "CHANEL";
}

export function GoodToKnow({
  product,
  runtimeConfig,
  configProps,
  flags,
  experiencesRawObject,
}: Pick<
  StandardProps,
  "product" | "runtimeConfig" | "configProps" | "flags" | "experiencesRawObject"
>) {
  const { variant } = useVariant(product);
  if (!variant) return null;

  const ean = getEan(variant);
  const isChanel = isChanelProduct(product);
  const cleanBeautyBaseUrl = runtimeConfig?.cleanBeautyBaseUrl;
  const initialItemsToShow = configProps?.initialItemsToShow
    ? (configProps?.initialItemsToShow as number)
    : 10;

  return (
    ean !== EAN_NOT_FOUND &&
    !isChanel && (
      <GoodToKnowUI
        ean={ean}
        cleanBeautyBaseUrl={cleanBeautyBaseUrl}
        initialItemsToShow={initialItemsToShow}
        flags={flags}
        runtimeConfig={runtimeConfig}
        experiencesRawObject={experiencesRawObject}
      />
    )
  );
}
